<template>
  <b-form>
    <b-row>
      <b-col>
        <fcc-select
          class="mb-4"
          labelField="descricao"
          valueField="tpimportacaooutrasfases"
          v-model="opcao"
          :options="listaOpcoes"
          required
        >
          Lista de Opções para Importação
        </fcc-select>
      </b-col>
    </b-row>

    <fcc-alocacao
      v-if="opcao === 1"
      :base-url-publicacao="baseUrlPublicacao"
      :idoutfase="idoutfase"
      :controle-page="controlePage"
      :tp-importacao="opcao"
      :fases-e-aplicacoes="fasesEAplicacoes"
      :lista-fases="listaFases"
    />

    <fcc-processamento
      v-if="opcao === 2"
      :base-url-publicacao="baseUrlPublicacao"
      :idoutfase="idoutfase"
      :controle-page="controlePage"
      :tp-importacao="opcao"
      :lista-fases="listaFases"
    />

    <fcc-sub-judice
      v-if="opcao === 3"
      :base-url-publicacao="baseUrlPublicacao"
      :idoutfase="idoutfase"
      :controle-page="controlePage"
      :tp-importacao="opcao"
    />

    <fcc-metadado
      v-if="opcao === 4"
      :base-url-publicacao="baseUrlPublicacao"
      :idoutfase="idoutfase"
      :controle-page="controlePage"
      :tp-importacao="opcao"
      :lista-fases="listaFases"
    />
  </b-form>
</template>
<script>
import axios from 'axios'
import fccAlocacao from './fccAlocacao.vue'
import fccProcessamento from './fccProcessamento.vue'
import fccSubJudice from './fccSubJudice.vue'
import fccMetadado from './fccMetadado.vue'

export default {
  props: {
    baseUrlPublicacao: String,
    idoutfase: Number,
    controlePage: Object
  },
  components: {
    fccAlocacao,
    fccProcessamento,
    fccSubJudice,
    fccMetadado
  },
  data() {
    return {
      opcao: '',
      listaOpcoes: [],
      fasesEAplicacoes: []
    }
  },
  created() {
    this.listarTiposDeImportacao()
    this.listarFaseSpi()
  },
  computed: {
    listaFases() {
      return [...new Set(this.fasesEAplicacoes.map((item) => item.idfase))]
    }
  },
  methods: {
    listarFaseSpi() {
      axios
        .get(
          this.baseUrlPublicacao +
            'PublicacaoCorrecaoCadastral/FiltroCorrecaoCadastral/' +
            this.controlePage.spi,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(({ data }) => {
          this.fasesEAplicacoes = data
        })
        .catch(this.setErrorSystem)
    },
    listarTiposDeImportacao() {
      axios
        .get(
          this.baseUrlPublicacao + 'PublicacaoOutrasFases/ObterTiposImportacaoOutrasFases',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(({ data }) => {
          this.listaOpcoes = data
        })
        .catch(this.setErrorSystem)
    }
  }
}
</script>